export default {
  'Enter a promo code! First limit people receive amount coins':
    'Bitte Promocode eingeben! Die ersten erhalten Wertmünzen',
};
